import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';

export default function BotHeroFrame({ name, compact = false, image }) {
  const { colors } = useTheme(), size = compact ? 72 : 96;
  return <View accessibilityRole="image" accessible accessibilityLabel={`${name} avatar`}
    style={{ width: size, height: size, borderRadius: size / 4, overflow: 'hidden', alignSelf: 'center',
      alignItems: 'center', justifyContent: 'center', marginBottom: 20, backgroundColor: colors.solid_color_tertiary }}>
    {image || <Icon name="robot" size={size / 2} color={colors.text_color_secondary} />}
  </View>;
}
